import React from "react";

export const SizedBox = ({ width, height }) => {
  return (
    <div
      style={{ width: width ? width : 0, height: height ? height : 0 }}
    ></div>
  );
};
